import { apiUrl } from 'config';
import { fetchWithHandledResponse } from '../helpers';

export const fetchNodeInfo = resourceId => {
    return fetchWithHandledResponse(`${apiUrl}/common/get-node-info/${resourceId}`, {
        method: 'get',
    });
};
